import { Navigate } from 'react-router-dom'

import { useUserContext } from '@/context/user'
import { isBrowser } from '@/utils/isBrowser'

interface GuardProps {
  children: React.ReactNode
  asPath: string
  action?: string
}

const Guard = ({ children, asPath, action }: GuardProps) => {
  const { isSessionValid, hasPermission } = useUserContext()

  if (isBrowser() && !isSessionValid() && asPath !== '/' && !asPath.includes('/oauth')) {
    return <Navigate to="/" replace />
  }

  if (action && isBrowser() && isSessionValid() && asPath !== '/' && !hasPermission(action)) {
    return <Navigate to="/home" replace />
  }

  return <>{children}</>
}

export { Guard }
